export const LINKS = {
  shopAll: 'https://www.fournierenterprises.com/6.html',
  handTools: 'https://www.fournierenterprises.com/6m3/hand-tools.html',
  toolKits: 'https://www.fournierenterprises.com/6m3/metalworking-tools-kits.html',
  englishWheels: 'https://www.fournierenterprises.com/6m3/english-wheel.html',
  sheetMetalMachines: 'https://www.fournierenterprises.com/6m3/sheet-metal-machines.html',
  gasWelding: 'https://www.fournierenterprises.com/6m3/gas-welding.html',
  finishing: 'https://www.fournierenterprises.com/6m3/metal-finishing.html',
  booksDvds: 'https://www.fournierenterprises.com/6m3/books-dvds.html',
  eckold: 'https://www.fournierenterprises.com/6m3/eckold.html',
  punchFlare: 'https://www.fournierenterprises.com/6m3/punch-flares-punches.html',
  specials: 'https://www.fournierenterprises.com/6m3/sales-specials.html',
  giftCertificates: 'https://www.fournierenterprises.com/6m3/gift-certificates.html',
  workshops: 'https://www.fournierenterprises.com/14.html',
  privateTraining: 'https://www.fournierenterprises.com/6m3/workshops/private-training.html',
  fabrication: 'https://www.fournierenterprises.com/metalshaping.htm',
  story: 'https://www.fournierenterprises.com/About%20FENT.html',
  faq: 'https://www.fournierenterprises.com/FAQ.htm',
  testimonials: 'https://www.fournierenterprises.com/24.html',
  contact: 'https://www.fournierenterprises.com/email.html',
  terms: 'https://www.fournierenterprises.com/In_The_Shop.html',
  roadAndTrackFeature: 'https://www.fournierenterprises.com/uploaded/files/LostArt_Fournier.pdf',
} as const

export const IMAGES = {
  headerLogo: 'https://cdn.magicpatterns.com/uploads/joW6qqAvB7iLEyG8u7wFnj/fournier-logo-tight.png',
  heroEnglishWheel: 'https://cdn.magicpatterns.com/uploads/ga3Tkf2rW5HgwzCgCtq883/english-wheel-closeup.jpg',
  heroMetalPoster:
    'https://cdn.magicpatterns.com/uploads/16Jvb34AuXL1k8FXvLXKJh/fournier-reflected-light-poster.jpg',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/1sm_logo_crpd.jpg400x400.jpg',
  hero: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/Banner/slide1.png',
  workshopWelding:
    'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/FOURNIER%20Workshops/056-3060761402-O.jpg',
  jeffBucks:
    'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/Metal%20New/MFWADV3.jpg',
  jeffWheel:
    'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/048-3060761388-O.jpg',
  shopBuck:
    'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/home%20page%20shot%20309_239a.jpg',
  wheelInUse:
    'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/main/machine%201.png',
  malletSet: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/fbmset.jpg',
  eckold: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/ECKOLD%20Kraftformer%20KF%20170PD.jpg',
  beadRoller: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/210-24-bead-roller-24in.jpg',
  finishingPicks: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/Bullseye_set.jpg',
  handbook: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/cart_images/d_16134_1.jpg',
  formingHead: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/MFH09.jpg',
  fabricatedTank: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/fabrication/1.png',
  fabricatedBody: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/fabrication/3.png',
  shotBag: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/LSB_12.jpg',
  metalAce: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/ma-30f.jpg',
  torch: 'https://drwzpk38qkpfb.cloudfront.net/www.fournierenterprises.com/uploaded/images/dhc-2000.jpg',
  customCoachbuilding:
    'https://cdn.magicpatterns.com/uploads/o6yZLMrWvShQkngTW4yfQz/custom-coachbuilding-clean-wall.png',
} as const

export const CONTACT = {
  phoneLabel: '586-323-9160',
  phoneHref: 'tel:+15863239160',
  email: 'orders@fournierenterprises.com',
  addressLine1: '17 N Rose St., Suite A',
  addressLine2: 'Mt. Clemens, MI 48043',
} as const

export const VIDEO = {
  heroMetalShaping:
    'https://cdn.magicpatterns.com/uploads/4fEGwf3hRJwVyMTYJRz54S/fournier-reflected-light-loop.mp4',
} as const

export type Category = {
  name: string
  description: string
  href: string
  image?: string
  imageAlt?: string
}

export const CATEGORIES: Category[] = [
  {
    name: 'Hand Tools',
    description: 'Hammers, dollies, mallets and bags for shaping panels by hand.',
    href: LINKS.handTools,
    image: IMAGES.malletSet,
    imageAlt: 'Fournier bossing mallet set laid out on a plain background',
  },
  {
    name: 'English Wheels',
    description: 'Wheeling machines and anvil sets for smoothing and crowning panels.',
    href: LINKS.englishWheels,
    image: IMAGES.metalAce,
    imageAlt: 'MetalAce 30F Classic Series English wheel',
  },
  {
    name: 'Sheet Metal Machines',
    description: 'Shop machines for cutting, bending, beading, shrinking and stretching.',
    href: LINKS.sheetMetalMachines,
    image: IMAGES.beadRoller,
    imageAlt: 'Bench-mounted bead roller for sheet metal',
  },
  {
    name: 'Gas Welding',
    description: 'Torches, tips and gas welding supplies for panel work and brazing.',
    href: LINKS.gasWelding,
    image: IMAGES.torch,
    imageAlt: 'DHC 2000 welding and cutting torch',
  },
  {
    name: 'Metal Finishing',
    description: 'Forming heads, files, bullseye picks and finishing supplies.',
    href: LINKS.finishing,
    image: IMAGES.finishingPicks,
    imageAlt: 'Set of bullseye picks for metal finishing',
  },
  {
    name: 'Books & DVDs',
    description: 'Metal shaping and fabrication instruction from experienced makers.',
    href: LINKS.booksDvds,
    image: IMAGES.handbook,
    imageAlt: "Metal Fabricator's Handbook by Ron and Sue Fournier",
  },
]

export const SECONDARY_CATALOG_LINKS = [
  { name: 'Punch & Flare Tools', href: LINKS.punchFlare },
  { name: 'Tools & Kits', href: LINKS.toolKits },
  { name: 'Sales & Specials', href: LINKS.specials },
  { name: 'Gift Certificates', href: LINKS.giftCertificates },
]

export type Product = {
  name: string
  code: string
  use: string
  href: string
  image: string
  alt: string
}

export const FEATURED_PRODUCTS: Product[] = [
  {
    name: 'Bossing Mallets: 3 Piece Set',
    code: 'FBMSET',
    use: 'Three bossing mallets with different head radii for shaping aluminum and mild steel.',
    href: 'https://www.fournierenterprises.com/m3/FBMSET--bossing-mallets-3-piece-set-fbmset.html',
    image: IMAGES.malletSet,
    alt: 'Set of three Fournier bossing mallets with wooden handles',
  },
  {
    name: 'Classic Bowl Forming Head',
    code: 'MFH09',
    use: 'A cast forming head for shaping and planishing curved sheet metal.',
    href: 'https://www.fournierenterprises.com/m3/MFH09--classic-bowl-forming-head-mfh09.html',
    image: IMAGES.formingHead,
    alt: 'Classic Bowl Forming Head for shaping curved sheet metal',
  },
  {
    name: 'MetalAce 30F Classic Series English Wheel',
    code: 'MA30F',
    use: 'A floor-standing wheel for smoothing and crowning shaped panels.',
    href: 'https://www.fournierenterprises.com/m3/MA30F--english-wheel-metalace-30f-classic-series-ma30f.html',
    image: IMAGES.metalAce,
    alt: 'MetalAce 30F Classic Series English wheel with anvil wheels',
  },
  {
    name: 'DHC 2000 Welding & Cutting Torch',
    code: 'W3000DVD',
    use: 'A gas torch for welding, brazing and cutting thin sheet in panel work.',
    href: 'https://www.fournierenterprises.com/m3/W3000DVD--dhc-2000-welding-cutting-torch-w3000dvd.html',
    image: IMAGES.torch,
    alt: 'DHC 2000 welding and cutting torch with handle and tip',
  },
]
